<template>
  <div class="progress-circle">
    <div class="progress-circle__svg-container">
      <svg viewBox="0 0 40 40" class="progress-circle__svg">
        <circle class="progress-circle__ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" />
        <circle
          class="progress-circle__segment"
          :style="segementStyles"
          cx="20"
          cy="20"
          r="15.91549430918954"
          fill="transparent"
        />
      </svg>
      <div class="progress-circle__slot">
        <div>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dashoffset: {
      validator: value => {
        return value >= 0 && value <= 100;
      },
      type: Number,
      default: 0
    },
    value: {
      validator: value => {
        return value >= 0 && value <= 100;
      },
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isIntialized: false
    };
  },
  computed: {
    segementStyles() {
      return {
        'stroke-dasharray': `${this.segmentValue} ${100 - this.segmentValue}`,
        'stroke-dashoffset': this.dashoffset
      };
    },
    segmentValue() {
      if (!this.isIntialized) {
        return 0;
      }
      return this.value;
    }
  },
  mounted() {
    setTimeout(() => {
      this.isIntialized = true;
    }, 250);
  }
};
</script>
<style lang="scss" scoped>
.progress-circle {
  &__svg-container {
    margin: 0 auto;
    position: relative;
    width: 100%;
  }

  &__svg {
    height: 100%;
    min-height: 20rem;
    width: 100%;

    @media print {
      min-height: 15rem;
    }
  }

  @media print {
    .heading--lg {
      // @include font-size('heading', 'md');
    }
    .heading--sm {
      // @include font-size('subheading', 'xl');
    }
  }

  &__ring {
    stroke: color('dark');
    stroke-width: 2;
  }

  &__segment {
    stroke: color('gold');
    stroke-dasharray: 0 100;
    stroke-dashoffset: 0;
    stroke-width: 2.1;
    transform-origin: center;
    transition: stroke-dasharray 500ms;
  }

  &__slot {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    text-align: center;
    top: 0;
    width: 100%;
  }
}
</style>
